"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveRouteURL = exports.resolveRouteParams = exports.pageHasBeenRenamed = exports.hasRouteParams = exports.getPageParams = exports.decodeParams = exports.decodeParam = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _memoizeOne = _interopRequireDefault(require("memoize-one"));
var _validations = require("../components/PagesTree/CreatePage/validations");
var _objects = require("./objects");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var resolveRouteURL = exports.resolveRouteURL = function resolveRouteURL(match, location) {
  var resolvedURL = match.url || '';
  var pathname = location.pathname;
  return pathname.substring(resolvedURL.length);
};
var decodeParam = exports.decodeParam = function decodeParam(param) {
  return param === null || param === void 0 ? void 0 : param.replace(/%2C|%2F|%3F|%3A|%40|%26|%3D|%2B|%24|%23|%3B/g, decodeURIComponent);
};
var decodeParams = exports.decodeParams = (0, _memoizeOne.default)(function () {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(params).reduce(function (accum, key) {
    return _objectSpread(_objectSpread({}, accum), {}, (0, _defineProperty2.default)({}, key, decodeParam(params[key])));
  }, {});
});
var getPageParams = exports.getPageParams = function getPageParams(asset, pagePath) {
  var type = asset.type,
    groupId = asset.groupId,
    assetId = asset.assetId,
    version = asset.version,
    versionGroup = asset.versionGroup,
    minorVersion = asset.minorVersion;
  return {
    type: type,
    groupId: groupId,
    assetId: assetId,
    version: version,
    minorVersion: minorVersion,
    versionGroup: versionGroup,
    pagePath: pagePath
  };
};
var pageHasBeenRenamed = exports.pageHasBeenRenamed = function pageHasBeenRenamed(pageEditorState) {
  var pagePath = pageEditorState.pagePath,
    pageName = pageEditorState.pageName;
  var parsedPath = pagePath.split('/');
  var parsedName = pageName.split('/');
  if ((0, _validations.isPredefinedPage)(pagePath)) {
    return false;
  }
  return parsedPath[parsedPath.length - 1] !== parsedName[parsedName.length - 1];
};
var resolveRouteParams = exports.resolveRouteParams = (0, _memoizeOne.default)(function (match, location, routes) {
  var routeURL = resolveRouteURL(match, location);
  return routes.reduce(function (accum, route) {
    if (accum) {
      return accum;
    }
    var matchResult = route.match(routeURL);
    if (!matchResult) {
      return false;
    }
    return _objectSpread(_objectSpread({}, route), {}, {
      params: matchResult.params
    });
  }, false);
});
var hasRouteParams = exports.hasRouteParams = function hasRouteParams(match, location, routes) {
  var routeParams = resolveRouteParams(match, location, routes);
  return !(0, _objects.isEmpty)(routeParams.params);
};
//# sourceMappingURL=routes.js.map